function createNamedWrapperReducer(reducerFunction, name) {
    return (state, action) => {
        const { reducerName } = action;
        const isInitializationCall = state === undefined;
        if (reducerName !== name && !isInitializationCall)
            return state;
        return reducerFunction(state, action);
    };
}
export const withResetState = (initialState) => (baseReducer) => (state, action) => {
    return baseReducer(!!state ? Object.assign({}, state) : Object.assign({}, initialState), action);
};
export default createNamedWrapperReducer;
